@import '../../global/style/all-tenants/custom-properties/components-properties/splide-sliders';

:host {
  display: block;
  margin-bottom: var(--cms-components-mb);
  padding: 0;
  @include cms-base-font-100;
}

.cms-slider-inner {
  @include cms-default-grid-container;
}

.splide {
  @include splide-root;
}

.splide__sr {
  @include splide-sr;
}

.splide__track--draggable {
  @include splide-track-draggable;
}

.splide__container {
  @include splide-container;
}

.splide__list {
  @include splide-list;
}

.splide.is-initialized:not(.is-active) .splide__list {
  @include splide-initialized-not-active;
}

.splide.is-initialized,
.splide.is-rendered {
  @include splide-initialized-rendered;
}

.splide__slide {
  @include splide-slide;
}

.splide__slide img {
  vertical-align: bottom;
}

.splide__track {
  @include splide-track;
}

.slider-text-wrapper {
  --cms-font-size-150: 1rem;
  padding: var(--cms-spacing-075) var(--cms-spacing-075) var(--cms-spacing-075) 0;
  color: var(--cms-theme-text-color);
}

.slider-text-wrapper p {
  margin-top: 0;
}

.slider-text-wrapper a {
  text-decoration: underline;
  color: var(--cms-theme-text-color);

  &:hover {
    text-decoration: none;
  }
}

.splide-arrow {
  @include splide-arrow;
}

.splide__arrow--prev {
  @include splide-arrow-prev;
}

.splide__arrow--next {
  @include splide-arrow-next;
}